import ajaxRequest from 'utils/_ajax-request.js'
import dayjs from "dayjs";
import accountOrderDetail from "../../3-section/section-account-order-detail/_index";
import adminOrderDetail from '3-section/section-admin-order-detail/_index.js'

const openOrderDetail = (orderUrl, orderId, typeUrl) => {
  ajaxRequest(
    (xhr, error) => {
      if( error ) {
        return false
      }
      let pageAjax = document.getElementById('page-ajax')
      pageAjax.innerHTML = xhr.responseText
      pageAjax.classList.remove('-is-hidden')

      if( typeUrl === 'admin' ) {
        adminOrderDetail(
          '#order-status-history-link',
          '#order-status-history-close'
        )(xhr)
      }
      else {
        accountOrderDetail(
          '#order-status-history-link',
          '#order-status-history-close'
        )(xhr)
      }
    },
    (orderUrl+'?ajax=1')
      .replaceAll('{!_locale}', (document.documentElement.lang || 'en'))
      .replaceAll('{!id}', orderId)
  )
}

const loadNotifications = (orderUrl, typeUrl) => {
  const formElement = document.getElementById('filter-form');
  if( formElement ) {
    let formData = new FormData(formElement)

    let searchParams = new URLSearchParams(window.location.search);

    if( searchParams.has('sorts[0][field]') ) {
      formData.append('sorts[0][field]', searchParams.get('sorts[0][field]'));
      formData.append('sorts[0][order]', searchParams.get('sorts[0][order]'));
    }

    if( searchParams.has('sorts[1][field]') ) {
      formData.append('sorts[1][field]', searchParams.get('sorts[1][field]'));
      formData.append('sorts[1][order]', searchParams.get('sorts[1][order]'));
    }


    const periodFromElement = document.getElementById('order_filter_period_from')
    const periodToElement = document.getElementById('order_filter_period_to')

    if( periodFromElement && periodFromElement._flatpickr.latestSelectedDateObj ) {
      formData.set('filters[period_from]', Math.floor(periodFromElement._flatpickr.latestSelectedDateObj.getTime() / 1000));
    }
    if( periodToElement && periodToElement._flatpickr.latestSelectedDateObj ) {
      formData.set('filters[period_to]', Math.floor(periodToElement._flatpickr.latestSelectedDateObj.getTime() / 1000));
    }

    const queryString = new URLSearchParams(formData).toString()
    let url = window.location.protocol + "//" + window.location.host + "" + window.location.pathname + '?' + queryString;
    url = url.replaceAll('/orders/?', ('/orders/notifications?'))

    ajaxRequest(
      (xhr, error) => {
        if( error ) {
          return false
        }

        const data = JSON.parse(xhr.response)
        //console.log('notications', data)

        let notifications = []
        //let isExistNewBubbles = false
        //let notificationsIdsNew = []

        /*for (let orderId in data['lastMessages']) {
          if( data['notifications'].hasOwnProperty(orderId) && data['notifications'][orderId] ) {
            notifications.push(
              `<div class="order-notification__item" data-order="${ orderId }">
                  <div class="order-notification__text">
                      ${ data['lastMessages'][orderId] }
                  </div>
              </div>`);
          }
        }*/

        for (let orderId in data['notifications']) {
          notifications.push(
            `<div class="order-notification__item" data-order="${ orderId }" data-order="${ data['notifications'][orderId]['id'] }">
                <div class="order-notification__text">
                    ${ data['notifications'][orderId]['text'] }
                </div>
            </div>`);

          /*if( notificationsIds.indexOf(data['notifications'][orderId]['id']) === -1 ) {
            isExistNewBubbles = true
          }

          notificationsIdsNew.push(data['notifications'][orderId]['id'])*/
        }

        //notificationsIds = notificationsIdsNew

        if( notifications.length > 0 ) {
          document.querySelector('.order-notification').style.display = "block";
        }
        else {
          document.querySelector('.order-notification').style.display = "none";
        }

        /*if( isExistNewBubbles ) {
          console.log('song notification')
          let audioObj = document.getElementById('notification-audio');
          if( audioObj ) {
            audioObj.volume = 0.5
            audioObj.play()
          }
        }*/

        document.querySelector('.order-notification__content').innerHTML = notifications.join('');

        const bubbles = document.querySelectorAll('.order-notification__item')
        bubbles.forEach((element)=>{
          element.addEventListener('click', (event) => {
            const orderId = element.getAttribute('data-order')

            /*const index = notificationsIds.indexOf( element.getAttribute('data-id') );
            if (index > -1) {
              notificationsIds.splice(index, 1);
            }*/

            element.remove()

            const notifications = document.querySelectorAll('.order-notification__item')
            if( notifications.length <= 0 ) {
              const notificationBlock = document.querySelector('.order-notification')
              if(notificationBlock) {
                notificationBlock.classList.remove('--open')
                notificationBlock.style.display = "none";
              }
            }

            openOrderDetail(orderUrl, orderId, typeUrl)
          })
        })

      },
      (url),
      {},
      'GET'
    )
  }
}


//let notificationsIds = []

let startPlay = false

export default (

) => {

  /*document.body.addEventListener('touchstart', function() {
    if( startPlay === false ) {
      let audioObj = document.getElementById('notification-audio');
      if( audioObj ) {
        audioObj.volume = 0.5
        audioObj.play()
        audioObj.pause()
        audioObj.currentTime = 0
      }
      startPlay = true
    }

  }, false)*/


  const notificationBlock = document.querySelector('.order-notification')
  if (!notificationBlock) {
    return
  }

  const typeUrl = notificationBlock.getAttribute('data-type')
  // '/{!_locale}/account/orders/{!id}'
  const orderUrl = '/{!_locale}/'+ typeUrl +'/orders/{!id}'

  /*if( window.innerWidth < 768 ) {

    const notificationOpenBtn = document.querySelector('.order-notification__button-show')
    if (!notificationOpenBtn) {
      return
    }

    const notificationCloseBtn = document.querySelector('.order-notification__button-hide')
    if (!notificationCloseBtn) {
      return
    }

    notificationOpenBtn.addEventListener('click', (event) => {
      notificationBlock.classList.add('--open')
    })

    notificationCloseBtn.addEventListener('click', (event) => {
      notificationBlock.classList.remove('--open')
    })

    var sidebar = new GeminiScrollbar({
      element: document.querySelector('.order-notification__list'),
      forceGemini: true,
      onResize: function() {}
    }).create();
  }*/


  const bubbles = document.querySelectorAll('.order-notification__item')
  bubbles.forEach((element)=>{

    //notificationsIds.push( parseInt(element.getAttribute('data-id')) )

    element.addEventListener('click', (event) => {
      const orderId = element.getAttribute('data-order')

      /*const index = notificationsIds.indexOf( element.getAttribute('data-id') );
      if (index > -1) {
        notificationsIds.splice(index, 1);
      }*/

      element.remove()

      const notifications = document.querySelectorAll('.order-notification__item')
      if( notifications.length <= 0 ) {
        notificationBlock.classList.remove('--open')
        notificationBlock.style.display = "none";
      }

      const themeAdmin = document.querySelector('.order-list-admin__body-item[data-id="'+orderId+'"] .order-list-admin__value-notification')
      if( themeAdmin ) {
        themeAdmin.classList.remove('order-list-admin__value-notification--alert')
      }
      const themeAccount = document.querySelector('.order-list__body-item[data-id="'+orderId+'"] .order-list__value-notification')
      if( themeAccount ) {
        themeAccount.classList.remove('order-list__value-notification--alert')
      }
      openOrderDetail(orderUrl, orderId, typeUrl)
    })
  })

  setInterval(function(){loadNotifications(orderUrl, typeUrl)}, 60000)

  //loadNotifications()


  let searchParams = new URLSearchParams(window.location.search);
  if( searchParams.has('order_id') ) {
    const orderId = searchParams.get('order_id')
    if( orderId ) {
      openOrderDetail(orderUrl, orderId, typeUrl)
    }
  }


  /*if(window.location.hash) {
    let hash = window.location.hash
    let regexp = /order-\d/
    let matchResult = hash.match(regexp)
    if( matchResult && matchResult[0] ) {
      const orderId = matchResult[0].replace('order-', '')
      if( orderId ) {
        openOrderDetail(orderUrl, orderId)
      }
    }
  }*/

}

